<template>
    <van-row class="footer-content">
      <van-col :span="24" class="row-content">河姆渡方案馆 msolution.homedo.com</van-col>
      <van-col :span="24" class="row-content">上海市浦东新区沪南路4888号2楼 400-807-7117转9</van-col>
    </van-row>
</template>

<script>
import { Row, Col } from 'vant'
export default {
  name: 'm-solution-footer',
  components: { Row, Col }
}
</script>

<style lang="scss" scoped>
.footer-content{
  .row-content{
    text-align: center;
    line-height: 37px;
    background-color: white;
    color: #a0a0a0;
    font-size: 11px;
    border-top: 1px solid #d8d8d8;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue